import { render, staticRenderFns } from "./ServiceTabs.vue?vue&type=template&id=fcb1dd64&scoped=true&"
import script from "./ServiceTabs.vue?vue&type=script&lang=js&"
export * from "./ServiceTabs.vue?vue&type=script&lang=js&"
import style0 from "./ServiceTabs.vue?vue&type=style&index=0&id=fcb1dd64&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcb1dd64",
  null
  
)

export default component.exports